import styled from 'styled-components';

export const TitleContainer = styled.div`
  margin-bottom: 8px;
  overflow: hidden;

  p {
    font-weight: 700 !important;
    font-size: 21px;
    line-height: 120%;
    letter-spacing: -0.02em;
    color: var(--normal-title-color);
  }

  &.simple-card {
    margin-bottom: 13px;

    p {
      font-weight: 600;
      font-size: 20px;
    }
  }

  @media (max-width: 768px) {
    &.simple-responsive p {
      font-size: 18px;
    }
  }
`;

export const DescriptionContainer = styled.div`
  overflow: hidden;

  p {
    font-size: 16px;
    color: var(--normal-description-color);
  }

  @media (max-width: 768px) {
    &.simple-responsive {
      display: none;
    }
  }
`;

export const QuoteContainer = styled.div`
  overflow: hidden;

  p {
    font-size: 20px;
    color: var(--normal-title-color);
  }

  &.description-color {
    p {
      color: var(--normal-description-color);
    }
  }

  @media (max-width: 768px) {
    p {
      font-size: 17px;
    }
  }
`;

export const AuthorContainer = styled.div`
  margin-top: 24px;

  p {
    font-size: 16px;
    color: var(--normal-title-color);
  }

  @media (max-width: 768px) {
    margin-top: 21px;
  }
`;

export const ImageContainer = styled.div`
  height: 72px;
  display: flex;
  align-items: center;
  margin-bottom: 48px;

  img {
    object-fit: contain;
    max-height: 100%;
  }

  @media (max-width: 768px) {
    height: 60px;
    margin-bottom: 25px;
  }
`;

export const IconContainer = styled.div`
  margin-bottom: 32px;
  position: relative;
  display: flex;
  justify-content: flex-start;

  &:before {
    content: ' ';
    width: 80px;
    height: 80px;
    position: absolute;
    border: 3px solid #e5ebee;
    border-radius: 50%;
    left: 0;
    top: 0;
    z-index: 2;
  }

  .icon-card--image {
    width: 80px;
    height: 80px;
  }

  &.align-center {
    justify-content: center;

    &:before {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &.align-right {
    justify-content: flex-end;

    &:before {
      left: auto;
      right: 0;
    }
  }

  @media (max-width: 768px) {
    &:before {
      content: ' ';
      width: 64px;
      height: 64px;
      position: absolute;
      border: 3px solid #e5ebee;
      border-radius: 50%;
      z-index: 1;
    }

    .icon-card--image,
    .st-icon-wrapper {
      width: 64px !important;
      height: 64px !important;
      min-width: 64px !important;

      img {
        width: 64px;
        height: 64px;
      }
    }
  }
`;

export const ComparisonContainer = styled.div`
  width: 100%;

  .comparison-card--main-logo {
    display: flex;
    width: 100%;
    text-align: center;

    svg {
      max-height: 48px;
      max-width: 100%;
      width: 100%;
    }
  }

  .comparison-card--other-logo {
    width: 100%;
    height: 36px;
    text-align: center;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .comparison-card--vs-text {
    font-weight: 900;
    font-size: 25px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.02em;
    color: var(--normal-title-color);
    margin: 32px 0;
  }
`;

export const FooterPercentContainer = styled.div`
  position: absolute;
  bottom: 32px;

  .footer-percent--percent {
    display: flex;

    p {
      font-size: 49px;
      font-weight: 600;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: var(--blue-video);
      padding: 0;
      margin: 0 0 4px;
    }

    & > svg {
      vertical-align: top;
      margin-top: 5px;
      margin-left: 10px;
    }
  }

  .footer-percent--description {
    color: var(--neutral-text-color);
  }

  @media (max-width: 768px) {
    bottom: 24px;

    .footer-percent--percent {
      p {
        font-size: 29px;
      }

      & > svg {
        width: 12px;
        height: 12px;
        margin-top: 2px;
      }
    }
  }
`;

export const FooterAuthorContainer = styled.div`
  position: absolute;
  bottom: 32px;

  .footer-author--author {
    font-weight: bold;
    font-size: 20px;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: var(--normal-title-color);
  }

  .footer-author--company {
    font-weight: 500;
    font-size: 13px;
    line-height: 150%;
    color: var(--normal-title-color);
    margin-top: 8px;
  }

  @media (max-width: 768px) {
    bottom: 24px;

    .footer-author--author {
      font-size: 18px;
    }

    .footer-author--company {
      margin-top: 4px;
    }
  }
`;
